import DragHelper from './DragHelper'
import { round } from './utils'

export const RangeAbstract = {
  props: {
    name: String,
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: [String, Number],
      default: 0
    },
    max: {
      type: [String, Number],
      default: 100
    },
    step: {
      type: [String, Number],
      default: 1
    }
  },

  data() {
    return {
      actualValue: null,
    }
  },

  created() {
    const { _min: min, _max: max } = this
    let defaultValue = Number(this.value)

    if (this.value == null || isNaN(defaultValue)) {
      if (min > max) {
        defaultValue = min
      } else {
        defaultValue = (min + max) / 2
      }
    }

    this.actualValue = this.round(defaultValue)
  },

  computed: {
    _min() {
      return Number(this.min)
    },

    _max() {
      return Number(this.max)
    },

    _step() {
      return Number(this.step)
    },

    valuePercent() {
      return (this.actualValue - this._min) / (this._max - this._min) * 100
    }
  },

  watch: {
    value(newValue) {
      const value = Number(newValue)
      if (newValue != null && !isNaN(value)) {
        this.actualValue = this.round(value)
      }
    },
    min() {
      this.actualValue = this.round(this.actualValue)
    },
    max() {
      this.actualValue = this.round(this.actualValue)
    }
  },

  methods: {
    drag(event, offset) {
      const { offsetWidth } = this.$refs.inner
      let oval = this.actualValue
      this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth))

      if (oval != this.actualValue) {
        this.emitEvent(this.actualValue)
      }
    },

    dragEnd(event, offset) {
      const { offsetWidth } = this.$refs.inner
      this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth))
      this.emitEvent(this.actualValue, true)
    },

    emitEvent(value, isDragEnd) {
      this.$emit('input', value)

      if (isDragEnd) {
        this.$emit('change', value)
      }
    },

    valueFromBounds(point, width) {
      return (point / width) * (this._max - this._min) + this._min
    },

    round(value) {
      return round(value, this._min, this._max, this._step)
    }
  },

  components: {
    DragHelper
  }
}



// WEBPACK FOOTER //
// ./src/js/shared/components/range-slider/range.js